import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import Message from "./Message";

function hasInfo(message: any, prev: any): boolean {
  const date = new Date(message.createdAt);
  const datePrev = prev ? new Date(prev.createdAt) : null;
  return (
    !prev ||
    prev.player.id !== message.player.id ||
    (datePrev && date.getTime() - datePrev.getTime() > 60000)
  );
}

const MessagesWrapper = styled.div`
  margin: 2px;
  overflow-y: auto;
  flex: 1 1 0;
  min-height: 250px;
`;

type MessagesProps = {
  messages: any[];
  player: any;
  team: any;
};

const Messages: React.FC<MessagesProps> = ({ messages, player, team }) => {
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = wrapperRef.current;
    if (el) el.scrollTop = el.scrollHeight;
  }, [messages]);

  return (
    <MessagesWrapper ref={wrapperRef}>
      {messages &&
        messages.map((message: any, index: number) => {
          return (
            <Message
              team={team}
              key={message.id}
              message={message}
              player={player}
              withInfo={index === 0 || hasInfo(message, messages[index - 1])}
            />
          );
        })}
    </MessagesWrapper>
  );
};

export default Messages;
